import { render, staticRenderFns } from "./PointDialog.vue?vue&type=template&id=b0151008&"
import script from "./PointDialog.vue?vue&type=script&lang=js&"
export * from "./PointDialog.vue?vue&type=script&lang=js&"
import style0 from "./PointDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports